<template>

  <div>
    <nav-bar/>
    <search-bar/>

    <div class="page-content">
      <div class="p10 bg_white">订单管理>发货</div>



      <div class="bg_white mt10 fz14">
        <div class="ml20 pt20"  style="width: 1100px;margin: 0 auto">
          <!--    表头-->
          <div class="fr ac pb20" style="border-bottom: 1px solid #f5f5f5;">
            <div style="width: 482px">产品信息</div>
            <div style="width: 200px">产品价格</div>
            <div style="width: 200px">购买数量</div>
            <div style="width: 200px">发货数量</div>
          </div>
        </div>

        <!-- 列表 -->

        <div class="goods-list" style="width: 1100px;margin: 0 auto">

          <div style="background-color: #F0F6FF" class="p10 grey">
            <span>{{order.create_time}}</span>
            <span class="ml20">订单编号:{{order.order_no}}</span>
          </div>


          <div class="item border fr ac" style="height: 100px" v-for="(item,index) in order.orderGoodsBeans" :key="index">

            <div class="fr  ac p10" style="width:482px">
              <img style="width: 80px" :src="item.goods_img" alt="">
              <div class="ml20" style="width: 150px">{{item.goods_name}} {{item.goods_standard_name}}</div>
            </div>

            <div style="width: 200px">{{item.goods_price}}</div>
            <div style="width: 200px">{{item.goods_num}}</div>
            <div style="width: 200px">
              <el-input class="input-count" v-model="send_form.json[index].send_count" v-if="item.is_merchants_send==0" type="number"  :max="item.goods_num-item.merchants_send_count" style="width: 56px;text-align: center;border-left: 0"></el-input>
              <el-input v-else disabled style="width: 56px;text-align: center" value="已发完"></el-input>
            </div>

          </div>

        </div>
        <!--    物流公司-->
        <div class="mt50 ml50">
          <el-form label-width="80px">

            <el-form-item label="物流公司">
              <el-select v-model="send_form.current_logistics_index" @change="onLogisticsChange" placeholder="请选择物流公司">
                <el-option :label="item.logistics_name" :value="index" v-for="(item,index) in logistics_list"
                           :key="index"></el-option>
              </el-select>
            </el-form-item>

            <!--      物流单号-->
            <el-form-item label="物流单号">


              <el-input style="width: 300px" v-model="send_form.logistics_no"></el-input>
            </el-form-item>
          </el-form>


        </div>


        <!--    确定发货-->

        <div class="fr jc ac" style="margin-top: 200px;margin-bottom: 100px">
          <el-button @click="submit" type="primary">确定发货</el-button>
        </div>


      </div>


    </div>

    <footer-bar/>


  </div>


</template>

<script>
  import NavBar from "@/components/NavBar";
  import SearchBar from "@/components/SearchBar";
  import FooterBar from "@/components/FooterBar";

  export default {
    data() {
      return {

        //订单
        order: {},
        //物流公司列表
        logistics_list: [],
        //  发货表单
        send_form: {
          current_logistics_index: "",
          order_merchants_id: "",
          logistics_name: "",
          logistics_pinyin: "",
          logistics_no: "",
          json: [],
        }
      }
    }, mounted() {
      let param = this.$route.query;
      this.order = param.order;
      console.log(this.order);

      this.send_form.order_merchants_id = this.order.order_merchants_id;
      //根据商品数量 添加发货信息
      let json = [];
      for (let i = 0; i < this.order.orderGoodsBeans.length; i++) {
        let goods = this.order.orderGoodsBeans[i];

        let obj = {
          order_goods_id: goods.order_goods_id,
          send_count: 0
        };
        json.push(obj);

        this.send_form.json = json;
      }

      //获取物流公司列表
      this.getLogisticsList();
    }
    , methods: {

      //选择物流公司
      onLogisticsChange(index) {

        this.send_form.logistics_name = this.logistics_list[index].logistics_name;
        this.send_form.logistics_pinyin = this.logistics_list[index].logistics_pinyin

      },
      //  获取物流公司列表
      getLogisticsList() {
        this.post("orderInterfaces/v1.0/getLogisticss").then(res => {
          this.logistics_list = res.data;
        })

      },

      //发货
      submit() {

        let param = JSON.parse(JSON.stringify(this.send_form));
        if (!param.logistics_name) {
          this.$message("请选择物流公司")
          return;
        }

        if (!param.logistics_no) {
          this.$message("请输入物流单号")
          return;
        }


        let json = param.json;
        for (let i = 0; i < json.length; i++) {
          if (json[i].send_count == 0) {
            json.splice(i, 1)
          }

        }

        if (json.length == 0) {
          this.$message("请选择商品");
          return;
        }

        param.json = JSON.stringify(json);
        this.post("orderInterfaces/v1.0/merchantsSendOrder", param).then(res => {
          this.$message("发货成功 ");
          this.back();

        })
      }

    }
    , components: {NavBar, SearchBar, FooterBar,}
  }
</script>

<style scoped lang="scss">
  .border {
    border: 1px solid #f5f5f5;
    margin: -1px;
  }
  .page-content {
    width: 1200px;
    margin: 20px auto;
  }
  .input-count >>> .el-input__inner {
    border: none;
    border-bottom: 1px solid #333333;
    border-radius: 0;
  }
</style>


// WEBPACK FOOTER //
// src/page/me/merchantsOrder/send.vue